import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import {
  Modal,
  ModalBody,
  ModalHeading,
  ModalHeader,
} from "@twilio-paste/core/modal";
import { Attachment } from "@twiliointernal/e2-commons-shared-definitions";

interface ImagePreviewModalProps {
  image: Attachment;
  isOpen: boolean;
  onDismiss: () => void;
}

const ImagePreviewModal = ({
  isOpen = false,
  image,
  onDismiss,
}: ImagePreviewModalProps): ReactElement => {
  const modalHeadingId = `modalHeading-${image.name}`;

  return (
    <Modal
      ariaLabelledby={modalHeadingId}
      isOpen={isOpen}
      onDismiss={onDismiss}
      size="default"
    >
      <ModalHeader>
        <ModalHeading as="h4" id={modalHeadingId}>
          {image.name}
        </ModalHeading>
      </ModalHeader>
      <ModalBody>
        <Box display="flex" maxHeight="size70">
          <img
            src={image.url}
            alt={image.name}
            style={{
              minWidth: "100%",
              minHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default ImagePreviewModal;
